/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenericZohoValuesAdminDto } from '../models/GenericZohoValuesAdminDto';
import type { Pagination1OfServiceAdminDto } from '../models/Pagination1OfServiceAdminDto';
import type { PostPutGenericZohoValuesAdminRequest } from '../models/PostPutGenericZohoValuesAdminRequest';
import type { PostServiceRequestAdmin } from '../models/PostServiceRequestAdmin';
import type { PutServiceRequestAdmin } from '../models/PutServiceRequestAdmin';
import type { ServiceAdminDto } from '../models/ServiceAdminDto';
import type { ServiceClientDto } from '../models/ServiceClientDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicesService {
    /**
     * @returns ServiceClientDto OK
     * @throws ApiError
     */
    public static getServicesClient({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<ServiceClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/services/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewServices`
     * @returns ServiceAdminDto OK
     * @throws ApiError
     */
    public static getServiceAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/services/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageServices`
     * @returns ServiceAdminDto OK
     * @throws ApiError
     */
    public static putServiceAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutServiceRequestAdmin,
    }): CancelablePromise<ServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/services/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteServices`
     * @returns ServiceAdminDto OK
     * @throws ApiError
     */
    public static deleteServiceAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/services/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewServices`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static getServiceGenericZohoValuesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/services/{id}/generic-zoho-values',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageServices`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static putServiceGenericZohoValuesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutGenericZohoValuesAdminRequest,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/services/{id}/generic-zoho-values',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewServices`
     * @returns Pagination1OfServiceAdminDto OK
     * @throws ApiError
     */
    public static getServicesAdmin({
        id,
        regionId,
        searchWord,
        page,
        limit,
    }: {
        id?: number,
        regionId?: number,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/services',
            query: {
                'id': id,
                'regionId': regionId,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageServices`
     * @returns ServiceAdminDto Created
     * @throws ApiError
     */
    public static postServiceAdmin({
        requestBody,
    }: {
        requestBody?: PostServiceRequestAdmin,
    }): CancelablePromise<ServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/services',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageServices`
     * @returns ServiceAdminDto OK
     * @throws ApiError
     */
    public static changeServiceStatusAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ServiceAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/services/{id}/disable',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
